export const CASUAL_PAGE_CONFIG = {
  "title": "Retention",
  "titleCN": "留存",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/retention/index",
  "defaultTab": "newUsers",
  "className": "dbd-engagement-retention-casual",
  "tabList": [
    {
      "id": "newUsers",
      "tabName": "New Users",
      "tabNameCN": "新进留存分析",
      "isHaveNotification": true,
      "notificationPath": "/retention/index/newUsers",
      "path": "/retention/index/newUsers",
      "logConfig": {
        "pageId": "200801",
        "pageName": "engaementRetentionNewUsers",
        "extInfo": "engaementRetentionNewUsers",
        "pagePath": "/retention/index/newUsers"
      },
      "filters": [
        {
          "name": "RetentionMobileFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "retention/index/newUsers",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "segment-light",
                  "style": {
                    "margin-top": "20px"
                  },
                  "props": {
                    "config": {
                      "dataKey": "by_tab",
                      "showOnTimeType": [
                        "week",
                        "month"
                      ],
                      "defaultValueMap": {
                        "week": "aggs",
                        "month": "aggs"
                      },
                      "timeTypeOptionsMap": {
                        "week": [
                          {
                            "name": "Weekly Total",
                            "nameCn": "周汇总",
                            "value": "all",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated on a deduplicated user basis across a full calendar week, reflecting overall user scale and behavior.",
                              "textCn": "基于用户去重口径统计，反映自然周内的整体用户规模与行为"
                            }
                          },
                          {
                            "name": "Weekly Aggregations",
                            "nameCn": "周聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar week.",
                              "textCn": "基于自然周每日留存数据进行加权计算，取这周每一日对应的Day N日留存之和 / 周新进 得到对应的Day N留存"
                            }
                          }
                        ],
                        "month": [
                          {
                            "name": "Monthly Total",
                            "nameCn": "月汇总",
                            "value": "all",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated on a deduplicated user basis across a full calendar month, reflecting overall user scale and behavior.",
                              "textCn": "基于用户去重口径统计，反映自然月内的整体用户规模与行为"
                            }
                          },
                          {
                            "name": "Monthly Aggregations",
                            "nameCn": "月聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar month.",
                              "textCn": "基于自然月每日留存数据进行加权计算，取这月每一日对应的Day N日留存之和 / 月新进 得到对应的Day N留存"
                            }
                          }
                        ]
                      },
                      "options": []
                    }
                  },
                  "children": [
                    {
                      "name": "RetentionChartContentCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "retention/index",
                          "componentKey": "NewUsersRetentionTrendCo",
                          "data": {
                            "tag": "new",
                            "timeTypeIsShowCom": [
                              "day",
                              "week",
                              "month"
                            ]
                          }
                        }
                      ]
                    },
                    {
                      "name": "MetricComponent",
                      "path": "retention/index",
                      "componentKey": "RetentionReturnTableCo",
                      "props": {
                        "config": {
                          "accumulateSelectMultipleBoxClassName": "dbd-engagement-retention-casual-tracking-table__accumulate-select-multiple-box",
                          "dateOptionDisabled": false,
                          "tableMetric": {
                            "byDate": ["register_users"],
                            "aggs": ["register_users"],
                            "all": ["register_users"],
                            "scenarioExtraParams": {
                              "aggs": { "logical_flag": "weighted_daily_average" }
                            }
                          },
                          "keyDaysConfig": [
                            {
                              "value": 0,
                              "enName": "Key Days",
                              "cnName": "关键日"
                            },
                            {
                              "value": 30,
                              "enName": "1 ~ 30 Days",
                              "cnName": "1 ~ 30 日"
                            },
                            {
                              "value": 60,
                              "enName": "1 ~ 60 Days",
                              "cnName": "1 ~ 60 日"
                            },
                            {
                              "value": 90,
                              "enName": "1 ~ 90 Days",
                              "cnName": "1 ~ 90 日"
                            },
                            {
                              "value": 180,
                              "enName": "1 ~ 180 Days",
                              "cnName": "1 ~ 180 日"
                            },
                            {
                              "value": 270,
                              "enName": "1 ~ 270 Days",
                              "cnName": "1 ~ 270 日"
                            },
                            {
                              "value": 360,
                              "enName": "1 ~ 360 Days",
                              "cnName": "1 ~ 360 日"
                            }
                          ],
                          "title": "Retention New Users",
                          "titleCN": "新进用户留存",
                          "tableDisWidthMap": {
                            "version": 260,
                            "campaign": 146,
                            "ua_network": 160,
                            "bundle": 146,
                            "language": 146,
                            "channel": 146,
                            "system": 146,
                            "country": 146,
                            "region": 246
                          }
                        }
                      },
                      "data": {
                        "tag": "new",
                        "retentionColumsNum": "2"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "activeUsers",
      "tabName": "Active Users",
      "tabNameCN": "活跃留存分析",
      "isHaveNotification": true,
      "notificationPath": "/retention/index/activeUsers",
      "path": "/retention/index/activeUsers",
      "logConfig": {
        "pageId": "200802",
        "pageName": "engaementRetentionActiveUsers",
        "extInfo": "engaementRetentionActiveUsers",
        "pagePath": "/retention/index/activeUsers"
      },
      "filters": [
        {
          "name": "RetentionMobileFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "retention/index/activeUsers",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "segment-light",
                  "style": {
                    "margin-top": "16px"
                  },
                  "props": {
                    "config": {
                      "dataKey": "by_tab",
                      "showOnTimeType": [
                        "week",
                        "month"
                      ],
                      "defaultValueMap": {
                        "week": "aggs",
                        "month": "aggs"
                      },
                      "timeTypeOptionsMap": {
                        "week": [
                          {
                            "name": "Weekly Total",
                            "nameCn": "周汇总",
                            "value": "all",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated on a deduplicated user basis across a full calendar week, reflecting overall user scale and behavior.",
                              "textCn": "基于用户去重口径统计，反映自然周内的整体用户规模与行为"
                            }
                          },
                          {
                            "name": "Weekly Aggregations",
                            "nameCn": "周聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar week.",
                              "textCn": "基于自然周每日留存数据进行加权计算，取这周每一日对应的Day N日留存之和 / 周新进 得到对应的Day N留存"
                            }
                          }
                        ],
                        "month": [
                          {
                            "name": "Monthly Total",
                            "nameCn": "月汇总",
                            "value": "all",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated on a deduplicated user basis across a full calendar month, reflecting overall user scale and behavior.",
                              "textCn": "基于用户去重口径统计，反映自然月内的整体用户规模与行为"
                            }
                          },
                          {
                            "name": "Monthly Aggregations",
                            "nameCn": "月聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar month.",
                              "textCn": "基于自然月每日留存数据进行加权计算，取这月每一日对应的Day N日留存之和 / 月新进 得到对应的Day N留存"
                            }
                          }
                        ]
                      },
                      "options": []
                    }
                  },
                  "children": [
                    {
                      "name": "RetentionChartContentCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "retention/index",
                          "componentKey": "ActiveUsersRetentionTrendCo",
                          "data": {
                            "tag": "active",
                            "timeTypeIsShowCom": [
                              "day",
                              "week",
                              "month"
                            ]
                          }
                        }
                      ]
                    },
                    {
                      "name": "MetricComponent",
                      "path": "retention/index",
                      "componentKey": "RetentionReturnTableCo",
                      "props": {
                        "config": {
                          "accumulateSelectMultipleBoxClassName": "dbd-engagement-retention-casual-tracking-table__accumulate-select-multiple-box",
                          "dateOptionDisabled": false,
                          "tableMetric": {
                            "byDate": ["active_users"],
                            "aggs": ["avg_active_users"],
                            "all": ["avg_active_users"],
                            "scenarioExtraParams": {
                              "aggs": { "logical_flag": "weighted_daily_average" }
                            }
                          },
                          "keyDaysConfig": [
                            {
                              "value": 0,
                              "enName": "Key Days",
                              "cnName": "关键日"
                            },
                            {
                              "value": 30,
                              "enName": "1 ~ 30 Days",
                              "cnName": "1 ~ 30 日"
                            },
                            {
                              "value": 60,
                              "enName": "1 ~ 60 Days",
                              "cnName": "1 ~ 60 日"
                            },
                            {
                              "value": 90,
                              "enName": "1 ~ 90 Days",
                              "cnName": "1 ~ 90 日"
                            },
                            {
                              "value": 180,
                              "enName": "1 ~ 180 Days",
                              "cnName": "1 ~ 180 日"
                            },
                            {
                              "value": 270,
                              "enName": "1 ~ 270 Days",
                              "cnName": "1 ~ 270 日"
                            },
                            {
                              "value": 360,
                              "enName": "1 ~ 360 Days",
                              "cnName": "1 ~ 360 日"
                            }
                          ],
                          "title": "Retention Active Users",
                          "titleCN": "活跃用户留存",
                          "tableDisWidthMap": {
                            "version": 260,
                            "campaign": 146,
                            "ua_network": 160,
                            "bundle": 146,
                            "language": 146,
                            "channel": 146,
                            "system": 146,
                            "country": 146,
                            "region": 246
                          }
                        }
                      },
                      "data": {
                        "tag": "active",
                        "retentionColumsNum": "2"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "returnUsers",
      "tabName": "Return Users",
      "tabNameCN": "回流留存分析",
      "isHaveNotification": true,
      "notificationPath": "/retention/index/returnUsers",
      "path": "/retention/index/returnUsers",
      "logConfig": {
        "pageId": "200803",
        "pageName": "engaementRetentionReturnUsers",
        "extInfo": "engaementRetentionReturnUsers",
        "pagePath": "/retention/index/returnUsers"
      },
      "filters": [
        {
          "name": "RetentionMobileFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "retention/index/returnUsers",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "segment-light",
                  "style": {
                    "margin-top": "16px"
                  },
                  "props": {
                    "config": {
                      "dataKey": "by_tab",
                      "showOnTimeType": [
                        "week",
                        "month"
                      ],
                      "defaultValueMap": {
                        "week": "aggs",
                        "month": "aggs"
                      },
                      "timeTypeOptionsMap": {
                        "week": [
                          {
                            "name": "Weekly Total",
                            "nameCn": "周汇总",
                            "value": "all",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated on a deduplicated user basis across a full calendar week, reflecting overall user scale and behavior.",
                              "textCn": "基于用户去重口径统计，反映自然周内的整体用户规模与行为"
                            }
                          },
                          {
                            "name": "Weekly Aggregations",
                            "nameCn": "周聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar week.",
                              "textCn": "基于自然周每日留存数据进行加权计算，取这周每一日对应的Day N日留存之和 / 周新进 得到对应的Day N留存"
                            }
                          }
                        ],
                        "month": [
                          {
                            "name": "Monthly Total",
                            "nameCn": "月汇总",
                            "value": "all",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated on a deduplicated user basis across a full calendar month, reflecting overall user scale and behavior.",
                              "textCn": "基于用户去重口径统计，反映自然月内的整体用户规模与行为"
                            }
                          },
                          {
                            "name": "Monthly Aggregations",
                            "nameCn": "月聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar month.",
                              "textCn": "基于自然月每日留存数据进行加权计算，取这月每一日对应的Day N日留存之和 / 月新进 得到对应的Day N留存"
                            }
                          }
                        ]
                      },
                      "options": []
                    }
                  },
                  "children": [
                    {
                      "name": "RetentionChartContentCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "retention/index",
                          "componentKey": "ReturnUsersRetentionTrendCo",
                          "data": {
                            "tag": "return",
                            "timeTypeIsShowCom": [
                              "day",
                              "week",
                              "month"
                            ]
                          }
                        }
                      ]
                    },
                    {
                      "name": "MetricComponent",
                      "path": "retention/index",
                      "componentKey": "RetentionReturnTableCo",
                      "props": {
                        "config": {
                          "accumulateSelectMultipleBoxClassName": "dbd-engagement-retention-casual-tracking-table__accumulate-select-multiple-box",
                          "dateOptionDisabled": false,
                          "tableMetric": {
                            "byDate": ["return_users"],
                            "aggs": ["return_users"],
                            "all": ["return_users"],
                            "scenarioExtraParams": {
                              "aggs": { "logical_flag": "weighted_daily_average" }
                            }
                          },
                          "keyDaysConfig": [
                            {
                              "value": 0,
                              "enName": "Key Days",
                              "cnName": "关键日"
                            },
                            {
                              "value": 30,
                              "enName": "1 ~ 30 Days",
                              "cnName": "1 ~ 30 日"
                            },
                            {
                              "value": 60,
                              "enName": "1 ~ 60 Days",
                              "cnName": "1 ~ 60 日"
                            },
                            {
                              "value": 90,
                              "enName": "1 ~ 90 Days",
                              "cnName": "1 ~ 90 日"
                            },
                            {
                              "value": 180,
                              "enName": "1 ~ 180 Days",
                              "cnName": "1 ~ 180 日"
                            },
                            {
                              "value": 270,
                              "enName": "1 ~ 270 Days",
                              "cnName": "1 ~ 270 日"
                            },
                            {
                              "value": 360,
                              "enName": "1 ~ 360 Days",
                              "cnName": "1 ~ 360 日"
                            }
                          ],
                          "title": "Retention Return Users",
                          "titleCN": "回流用户留存",
                          "tableDisWidthMap": {
                            "version": 260,
                            "campaign": 146,
                            "ua_network": 160,
                            "bundle": 146,
                            "language": 146,
                            "channel": 146,
                            "system": 146,
                            "country": 146,
                            "region": 246
                          }
                        }
                      },
                      "data": {
                        "tag": "return",
                        "retentionColumsNum": "2"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "retentionReturnUsers",
      "tabName": "Retention & Return Users",
      "tabNameCN": "留存&回流用户留存分析",
      "isHaveNotification": true,
      "notificationPath": "/retention/index/retentionReturnUsers",
      "path": "/retention/index/retentionReturnUsers",
      "logConfig": {
        "pageId": "200803",
        "pageName": "engaementRetentionRetentionReturnUsers",
        "extInfo": "engaementRetentionRetentionReturnUsers",
        "pagePath": "/retention/index/retentionReturnUsers"
      },
      "filters": [
        {
          "name": "RetentionMobileFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "retention/index/retentionReturnUsers",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "segment-light",
                  "style": {
                    "margin-top": "16px"
                  },
                  "props": {
                    "config": {
                      "dataKey": "by_tab",
                      "showOnTimeType": [
                        "week",
                        "month"
                      ],
                      "timeTypeOptionsMap": {
                        "week": [
                          {
                            "name": "Weekly Aggregations",
                            "nameCn": "周聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar week.",
                              "textCn": "基于自然周每日留存数据进行加权计算，取这周每一日对应的Day N日留存之和 / 周新进 得到对应的Day N留存"
                            }
                          }
                        ],
                        "month": [
                          {
                            "name": "Monthly Aggregations",
                            "nameCn": "月聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "Calculated using weighted aggregation based on daily retention data within a calendar month.",
                              "textCn": "基于自然月每日留存数据进行加权计算，取这月每一日对应的Day N日留存之和 / 月新进 得到对应的Day N留存"
                            }
                          }
                        ]
                      },
                      "options": []
                    }
                  },
                  "children": [
                    {
                      "name": "RetentionChartContentCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "retention/index",
                          "componentKey": "RetentionReturnUsersRetentionTrendCo",
                          "data": {
                            "tag": "old_user",
                            "timeTypeIsShowCom": [
                              "day",
                              "week",
                              "month"
                            ]
                          }
                        }
                      ]
                    },
                    {
                      "name": "MetricComponent",
                      "path": "retention/index",
                      "componentKey": "RetentionReturnTableCo",
                      "props": {
                        "config": {
                          "accumulateSelectMultipleBoxClassName": "dbd-engagement-retention-casual-tracking-table__accumulate-select-multiple-box",
                          "dateOptionDisabled": false,
                          "tableMetric": {
                            "byDate": ["dau_users"],
                            "aggs": ["avg_dau_users"],
                            "all": ["avg_dau_users"],
                            "scenarioExtraParams": {
                              "aggs": { "logical_flag": "weighted_daily_average" }
                            }
                          },
                          "keyDaysConfig": [
                            {
                              "value": 0,
                              "enName": "Key Days",
                              "cnName": "关键日"
                            },
                            {
                              "value": 30,
                              "enName": "1 ~ 30 Days",
                              "cnName": "1 ~ 30 日"
                            },
                            {
                              "value": 60,
                              "enName": "1 ~ 60 Days",
                              "cnName": "1 ~ 60 日"
                            },
                            {
                              "value": 90,
                              "enName": "1 ~ 90 Days",
                              "cnName": "1 ~ 90 日"
                            },
                            {
                              "value": 180,
                              "enName": "1 ~ 180 Days",
                              "cnName": "1 ~ 180 日"
                            },
                            {
                              "value": 270,
                              "enName": "1 ~ 270 Days",
                              "cnName": "1 ~ 270 日"
                            },
                            {
                              "value": 360,
                              "enName": "1 ~ 360 Days",
                              "cnName": "1 ~ 360 日"
                            }
                          ],
                          "title": "Retention Analysis Retention & Return Users",
                          "titleCN": "留存&回流用户留存分析",
                          "tableDisWidthMap": {
                            "version": 260,
                            "campaign": 146,
                            "ua_network": 160,
                            "bundle": 146,
                            "language": 146,
                            "channel": 146,
                            "system": 146,
                            "country": 146,
                            "region": 246
                          }
                        },
                        "metricColumnWidth": {
                          "en": 240,
                          "cn": 190
                        }
                      },
                      "data": {
                        "tag": "old_user",
                        "retentionColumsNum": "2"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
